import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('templates', storeModule.createStoreModule('templates'))
